<script>
import {ref} from "vue";
import {useRoute} from "vue-router";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {Share} from "@capacitor/share";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import {Swiper, SwiperSlide} from 'swiper/vue';

// import router from "@/router";


export default {
  name: "DetailsExecutives",
  components: {NavbarPage, LoadingPage  , Swiper, SwiperSlide},


  beforeRouteEnter(to, from, next) {
    if (from.name == 'ProfileExecutives') {
      setTimeout(() => {
        document.getElementById('list').style.display = 'none'
      }, 500)
      next()
    } else {
      next()
    }
  },

  setup() {

    let user_id = ref(FreeWorld.PinkMan(localStorage.getItem('uid') , 'de'))

    let data_user = ref(null)
    let prof_id = ref(useRoute().params.prof_id)

    let loading = ref(false)

    let mark = ref(false)

    let pics = ref([])


    function load_data() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'executives', id: prof_id.value,}, 'Element', true).then((result) => {

        loading.value = false
        let res = result.data
        data_user.value = res
        // pics.value = res.gallery[0].pic_link
        change_data()

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, load_data)
      })

    }
    load_data()

    function change_data() {
      if (data_user.value.marke != 0) {
        mark.value = true
      } else {
        mark.value = false
      }
    }

    function open_slider(items) {

      let slider = document.getElementById('slider')
      let bakgeround = document.getElementById('slider_background')

      pics.value = items

      if (slider.style.display == 'block') {
        slider.style.display = 'none'
        bakgeround.style.display = 'none'
      } else {
        slider.style.display = 'block'
        bakgeround.style.display = 'block'
      }
    }

    function share_list() {
      let navbar = document.getElementById('share_list')
      let img_navbar = document.getElementById('up_share_list_img')

      if (navbar.style.height !== '40rem') {
        navbar.style.height = '40rem'
        img_navbar.classList.toggle("clicked");
      } else {
        navbar.style.height = '0px'
        img_navbar.classList.toggle("clicked");

      }
    }

    function mark_prod() {

      let div_mark = document.getElementById('div_mark')

      div_mark.style.pointerEvents = 'none'
      mark.value = !mark.value
      let data = {
        action: 'add',
        item_id: prof_id.value,
        type: 'executives',
      }
      FreeWorld.Heisenberg(data, 'user_marke', true).then((result) => {
        let res = result.data

        setTimeout(() => {
          if (res.event == 'mark delete') {
            mark.value = false
          } else if (res.event == 'mark add') {
            mark.value = true
          }
          div_mark.style.pointerEvents = 'auto'
        }, 1000)

      }).catch(() => {

        setTimeout(() => {
          mark.value = !mark.value
          div_mark.style.pointerEvents = 'auto'
        }, 1000)

        console.log('don`t mark')
      })

    }

    function share_prod() {
      Share.share({
        title: data_user.value.name,
        text: 'اپلیکیشن دکوبان',
        url: 'https://decobanapp.ir',
        dialogTitle: 'اشتراک گذاری برای دیگران',
      });
    }


    return {

      share_list,
      data_user,
      loading,
      open_slider,
      pics,
      mark_prod,
      mark,
      user_id,
      share_prod,

    }
  }
}


</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div @click="open_slider" id="slider_background" class="alert_background"></div>
  <div dir="ltr" id="slider" class="max_width px-3">

    <swiper
        :slides-per-view="1"
        :slides-per-group="1"
        :space-between="5"
        :pagination="true"
        :centeredSlides="true"
        :autoHeight="true"
        :navigation="true"
    >

      <swiper-slide dir="rtl" class="" v-for="(item , index) in pics" :key="index">
        <img style="max-height: 80vh"  class="w-100 rounded-4" :src="item" alt="">
      </swiper-slide>

    </swiper>

  </div>

  <div dir="ltr" id="main" :class="loading ? 'activeClass' : '' " class="bg-main">

    <div class="div-top-arrow bg-color d-flex align-items-center">

      <p class="m-0">
        پروفایل مجری
      </p>

      <div onclick="history.back()">
        <img class="svg-arrow" src="../assets/img/back.svg" alt="">
      </div>

    </div>
    <br>
    <br>
    <br>


    <div v-if="data_user != null" class="animate__animated animate__fadeIn p-body">

      <div class="div_img_products my-3">
        <div class="w-100 h-100 animated-background bg-white rounded-4">
          <img v-if="data_user.profile_pic == null " class="w-100 h-100 rounded-4"
               src="../assets/img/img-notavalible.jpg" alt="">
          <img v-else class="w-100 h-100 rounded-4" :src="data_user.profile_pic" alt="">
        </div>
      </div>

      <div class="mb-2">
        <div class="p-3 bg-white rounded-4 border-costom">
          <p class="font-5 text-right m-0">{{ data_user.name }}</p>
        </div>
      </div>

      <div  class="d-flex align-items-center p-3 bg-white rounded-4 border-costom mb-2" :class="data_user.active_business ? 'justify-content-between' : 'justify-content-end'">
        <p v-if="data_user.active_business" class="font-color-red font-5 m-0">دارای پروانه کسب</p>

        <div class="d-flex align-items-center justify-end">
          <p dir="rtl" class="font-4 text-right m-0">{{ data_user.work_years }}</p>

          <p class="font-4 ms-3 font-bold m-0"> : سابقه کاری</p>
        </div>
      </div>

      <div class="mb-2">
        <div class="bg-white rounded-4 p-body py-3 mb-3">
          <div class="d-flex align-items-center justify-content-end mb-3">
            <p class="font-5 m-0 mx-2 font-bold">
              آدرس محل کار
            </p>

            <img style="width: 20px" src="../assets/img/place.svg">
          </div>
          <div class="p-body">
            <!--            <p class="m-0 font-5 text-end mb-3">-->
            <!--              <span>{{ data_user.state }}</span>-->
            <!--              &nbsp;-->
            <!--              - -->
            <!--              &nbsp;-->
            <!--              <span>{{ data_user.city }}</span>-->
            <!--            </p>-->
            <p class="m-0 font-5 text-end">{{ data_user.address }}</p>
          </div>
        </div>
      </div>

      <div class="mb-2">
        <div class="bg-white rounded-4 p-body py-3 mb-3">
          <div class="d-flex align-items-center justify-content-end mb-3">
            <p class="font-5 m-0 mx-2 font-bold">
              ساعات کاری
            </p>

            <img style="width: 20px" src="../assets/img/clock.svg">
          </div>
          <div class="d-flex justify-content-evenly">
            <div class="d-flex flex-column align-items-center">
              <p class="m-0 font-5 text-end mb-3 font-bold">
                عصر تا شب
              </p>
              <p class="m-0 font-5 text-end d-flex">
                {{ data_user.time_work.end_evening }}
                &nbsp;
                تا
                &nbsp;
                <span>{{ data_user.time_work.start_evining }}</span>
              </p>
            </div>
            <div class="d-flex flex-column align-items-center">
              <p class="m-0 font-5 text-end mb-3 font-bold">
                صبح تا ظهر
              </p>
              <p class="m-0 font-5 text-end d-flex">
                <span>{{ data_user.time_work.end_morning }}</span>
                &nbsp;
                تا
                &nbsp;
                <span>{{ data_user.time_work.start_morning }}</span>
              </p>
            </div>
          </div>
        </div>

      </div>

      <div class="mb-2">
        <div class="d-flex flex-column p-3 bg-white rounded-4 border-costom align-items-center">
          <div class="w-100 d-flex align-items-center justify-content-end mb-3 align-items-center">
            <p class="font-5 m-0 mx-2 font-bold">
              :توضیحات و افتخارات
            </p>
            <img style="width: 20px" src="../assets/img/document.svg" alt="">
          </div>

          <div dir="rtl" class="w-100">
            <p class="m-0">{{ data_user.description }}</p>
          </div>

        </div>
      </div>

      <div class="mb-2">
        <div class="bg-white rounded-4 p-body py-3 mb-3">
          <div class="d-flex align-items-center justify-content-end mb-3">
            <p class="font-5 m-0 mx-2 font-bold">
              شماره های تماس
            </p>

            <img style="width: 20px" src="../assets/img/telephone_color.svg">
          </div>
          <div class="p-body">
            <p class="m-0 font-5 text-end mb-3">{{ data_user.phone }}</p>
            <p class="m-0 font-5 text-end">{{ data_user.landline_phone }}</p>
          </div>
        </div>
      </div>

      <div v-if="data_user.gallery.length > 0" class="mb-2">
        <div class="bg-white rounded-4 p-body py-3 mb-3">
          <div class="d-flex align-items-center justify-content-end mb-3">
            <p class="font-5 m-0 mx-2 font-bold">
              گالری نمونه کار
            </p>
            <img style="width: 20px" src="../assets/img/gallery.svg">
          </div>

          <div class="">

              <swiper
                  :slides-per-view="2.5"
                  :slides-per-group="2"
                  :space-between="5"
                  :navigation="true"
              >

                <swiper-slide v-for="item in data_user.gallery" :key="item.id">
                  <div style="height: 11rem" @click="open_slider(item.pic_link)">
                    <div class="animated-background h-80 mb-2 rounded-4 ">
                      <img class="rounded-4 h-100 w-100" :src="item.pic_link[0]" alt="">
                    </div>

                    <p class="m-0 font-4 text-center">{{ item.gallery_name }}</p>
                  </div>
                </swiper-slide>

              </swiper>

          </div>

        </div>


      </div>

    </div>

    <div id="list">
      <div v-if="data_user != null" id="div_share" class="div_share z-3">

        <div @click="share_list" class="holder_navbar_share z-5 animate__animated animate__fadeInLeft">
          <img id="up_share_list_img" style="width: 4rem" src="../assets/img/up_down.svg" alt="">
        </div>

        <div id="share_list" class="share_list d-flex flex-column bg-color px-1 align-items-center ">
          <br>

          <div @click="share_prod" class="d-flex flex-column align-items-center mb-2">
            <img style="width: 1.5rem" src="../assets/img/share.svg" alt="">
            <p class="m-0 font-7 text-white text-center my-2">
              اشتراک گذاری
            </p>
          </div>

          <div id="div_mark" @click="mark_prod" class="d-flex flex-column align-items-center mb-2">
            <img v-if="mark" style="width: 1.5rem" src="../assets/img/save_mark.svg" alt="">
            <img v-else style="width: 1.5rem" src="../assets/img/bookmark-white.svg" alt="">
            <p class="m-0 font-7 text-white text-center my-2">
              نشان کردن
            </p>
          </div>


          <div v-if="data_user.user_id == user_id" class="d-flex flex-column align-items-center mb-2">
            <img style="width: 1.5rem" src="../assets/img/disable_chats.svg" alt="">
            <p style="color:#666666" class="m-0 font-7 text-center my-2">
              چت با مجری
            </p>
          </div>


          <router-link v-else :to="{name:'UserChat', params:{user_id:user_id , type:'executives' , send:'user' , prof_id:data_user.id , name:data_user.name}}"
               class="d-flex text-decoration-none text-black flex-column align-items-center mb-2">
            <img style="width: 1.5rem" src="../assets/img/chat.svg" alt="">
            <p class="m-0 font-7 text-white text-center my-2">
              چت با مجری
            </p>
          </router-link>


          <a v-if="data_user.insta_link != null" :href="data_user.insta_link" target="_blank"
             class="d-flex text-decoration-none flex-column align-items-center mb-2">
            <img style="width: 1.5rem" src="../assets/img/instagram.svg" alt="">
            <p class="m-0 font-7 text-white text-center my-2 text-nowrap">
              اینستاگرام
            </p>
          </a>

          <div v-else class="d-flex flex-column align-items-center mb-2">
            <img style="width: 1.5rem" src="../assets/img/not_active_instagram.svg" alt="">
            <p style="color:#666666" class="m-0 font-7 text-center my-2">
              اینستاگرام
            </p>
          </div>


          <a v-if="data_user.telegram_link != null" :href="data_user.telegram_link" target="_blank"
             class="d-flex text-decoration-none flex-column align-items-center mb-2">
            <img style="width: 1.8rem" src="../assets/img/telegram.svg" alt="">
            <p class="m-0 font-7 text-white text-center my-2">
              تلگرام
            </p>
          </a>

          <div v-else class="d-flex flex-column align-items-center mb-2">
            <img style="width: 1.8rem" src="../assets/img/not_active_telegram.svg" alt="">
            <p style="color:#666666" class="m-0 font-7 text-center my-2">
              تلگرام
            </p>
          </div>

          <a v-if="data_user.web_link != null" :href="data_user.web_link" target="_blank"
             class="d-flex text-decoration-none flex-column align-items-center mb-2">
            <img style="width: 1.8rem" src="../assets/img/web.svg" alt="">
            <p class="m-0 font-7 text-white text-center my-2 text-nowrap">
              وبسایت
            </p>
          </a>

          <div v-else class="d-flex flex-column align-items-center mb-2">
            <img style="width: 1.8rem" src="../assets/img/not_active_web.svg" alt="">
            <p style="color:#666666" class="m-0 font-7 text-center my-2">
              وبسایت
            </p>
          </div>

          <a :href="data_user.rubika_link" :class="data_user.rubika_link === null ? 'pe-none':''" class="d-flex text-decoration-none flex-column align-items-center mb-2">
            <img v-if="data_user.rubika_link === null" style="width: 2rem" src="../assets/img/rubika-NA.png" alt="">
            <img v-else style="width: 2rem" src="../assets/img/rubikapng.parspng.com_.png" alt="">
            <p :style="data_user.rubika_link === null ? {color:'#666666'} : {color: 'white'}" class="m-0 font-6 text-center my-2">
              روبیکا
            </p>
          </a>

          <a :href="data_user.eita_link" :class="data_user.eita_link === null ? 'pe-none':''" class="d-flex text-decoration-none flex-column align-items-center mb-2">
            <img v-if="data_user.eita_link === null" style="width: 2rem" src="../assets/img/eta_NA.png" alt="">
            <img v-else style="width: 2rem" src="../assets/img/eta_A.png" alt="">
            <p :style="data_user.eita_link === null ? {color:'#666666'} : {color: 'white'}" class="m-0 font-6 text-center my-2">
              ایتا
            </p>
          </a>

        </div>
      </div>
    </div>

  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">
    <NavbarPage></NavbarPage>

    <div v-if="data_user != null" class="position-relative d-flex">

      <div style="left:0;width: calc(100% - 10.5rem)" class="position-absolute">
        <div class="w-90 p-body">
          <div class="animate__animated animate__fadeIn">
            <div class="d-flex justify-space-between align-items-center mb-7">
              <div style="width: 20rem;height: 20rem" class="rounded-4">
                <img v-if="data_user.profile_pic == null " class="w-100 h-100 rounded-4" src="../assets/img/img-notavalible.jpg" alt="">

                <img v-else class="w-100 h-100 rounded-4" :src="data_user.profile_pic" alt="">
              </div>

              <div style="width: calc(100% - 21rem)" class="d-flex flex-column justify-content-between">
                <div class="mb-2">
                  <div class="d-flex p-3 bg-white rounded-4 border-costom justify-content-between  align-items-center">
                    <div class="overflow-hidden w-70">
                      <p :class="data_user.name.length > 35 ? 'txtoverflow' : '' " class="m-0 d-flex font-bold font-5">
                        {{ data_user.name }}</p>
                    </div>
                  </div>
                </div>

                <div  class="d-flex align-items-center p-3 bg-white rounded-4 border-costom mb-2" :class="data_user.active_business ? 'justify-content-between' : 'justify-content-start'">
                  <div class="d-flex align-items-center justify-end">
                    <p class="font-4 ms-3 font-bold m-0"> سابقه کاری :</p>

                    <p dir="rtl" class="font-4 text-right m-0">{{ data_user.work_years }}</p>
                  </div>

                  <p v-if="data_user.active_business" class="font-color-red font-5 m-0">دارای پروانه کسب</p>
                </div>

                <div class="mb-2">
                  <div class="bg-white rounded-4 p-body py-3">
                    <div class="d-flex align-items-center mb-3">
                      <img style="width: 20px" src="../assets/img/clock.svg">

                      <p class="font-5 m-0 mx-2 font-bold">
                        ساعات کاری
                      </p>
                    </div>

                    <div class="d-flex justify-content-evenly">
                      <div class="d-flex flex-column align-items-center">
                        <p class="m-0 font-5 text-end mb-3 font-bold">
                          صبح تا ظهر
                        </p>
                        <p class="m-0 font-5 text-end d-flex">
                          <span>{{ data_user.time_work.start_morning }}</span>
                          &nbsp;
                          تا
                          &nbsp;
                          <span>{{ data_user.time_work.end_morning }}</span>
                        </p>
                      </div>

                      <div class="d-flex flex-column align-items-center">
                        <p class="m-0 font-5 text-end mb-3 font-bold">
                          عصر تا شب
                        </p>
                        <p class="m-0 font-5 text-end d-flex">
                          <span>{{ data_user.time_work.start_evining }}</span>
                          &nbsp;
                          تا
                          &nbsp;
                          {{ data_user.time_work.end_evening }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mb-2">
                  <div class="p-3 bg-white rounded-4 border-costom">
                    <div class="d-flex align-items-center mb-3">
                      <img style="width: 20px" src="../assets/img/place.svg">

                      <p class="font-5 m-0 mx-2 font-bold">
                        آدرس محل کار
                      </p>
                    </div>
                    <p class="m-0 font-5">{{ data_user.address }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-2">
              <div class="d-flex flex-column p-3 bg-white rounded-4 border-costom align-items-center">
                <div class="w-100 d-flex align-items-center mb-3 align-items-center">
                  <img style="width: 25px" src="../assets/img/document.svg" alt="">

                  <p class="font-5 m-0 mx-2 font-bold">توضیحات و افتخارات</p>
                </div>

                <div dir="rtl" class="w-100">
                  <p class="m-0">{{ data_user.description }}</p>
                </div>

              </div>
            </div>

            <div class="mb-2">
              <div class="bg-white rounded-4 p-body py-3 mb-3">
                <div class="d-flex align-items-center mb-3">
                  <img style="width: 25px" src="../assets/img/telephone_color.svg">

                  <p class="font-5 m-0 mx-2 font-bold">
                    شماره های تماس
                  </p>
                </div>
                <div class="p-body">
                  <p class="m-0 font-5 mb-3">{{ data_user.phone }}</p>
                  <p class="m-0 font-5">{{ data_user.landline_phone }}</p>
                </div>
              </div>
            </div>

            <div v-if="data_user.gallery.length > 0" class="mb-2">
              <div class="bg-white rounded-4 p-body py-3 mb-3">
                <div class="d-flex align-items-center mb-3">
                  <img style="width: 25px" src="../assets/img/gallery.svg">

                  <p class="font-5 m-0 mx-2 font-bold">
                    گالری نمونه کار
                  </p>
                </div>

                <div class="">

                  <swiper
                      :slides-per-view="3.5"
                      :slides-per-group="2"
                      :space-between="5"
                      :navigation="true"
                  >

                    <swiper-slide v-for="item in data_user.gallery" :key="item.id">
                      <div class="categories_gallery-web" @click="open_slider(item.pic_link)">
                        <div class="animated-background h-80 mb-2 rounded-4 ">
                          <img class="rounded-4 h-100 w-100" :src="item.pic_link[0]" alt="">
                        </div>

                        <p class="m-0 font-5 text-center">{{ item.gallery_name }}</p>
                      </div>
                    </swiper-slide>

                  </swiper>

                </div>

              </div>

            </div>

          </div>
        </div>
      </div>

      <div style="right: 0;width: 10rem;height: calc(100vh - 10rem)" class="animate__animated animate__fadeIn gap-3 position-fixed d-flex justify-content-center flex-column align-items-center">

        <div @click="share_prod" class="item_share d-flex flex-column align-items-center">
          <img style="width: 1.5rem;height: 1.5rem" src="../assets/img/share_web.svg" alt="">
          <p class="m-0 font-5 text-center my-2">
            اشتراک گذاری
          </p>
        </div>

        <div id="div_mark" @click="mark_prod" class="item_share d-flex flex-column align-items-center">
          <img v-if="mark" style="width: 1.5rem;height: 1.5rem" src="../assets/img/save_mark_web.svg" alt="">
          <img v-else style="width: 1.5rem;height: 1.5rem" src="../assets/img/bookmark-white-web.svg" alt="">
          <p class="m-0 font-5 text-center my-2">
            نشان کردن
          </p>
        </div>

        <router-link v-if="user_id !== data_user.user_id" :to="{name:'UserChat', params:{user_id:user_id , type:'executives' , send:'user' , prof_id:data_user.id , name:data_user.name}}"
             class="item_share d-flex text-decoration-none flex-column align-items-center">
          <img style="width: 1.5rem;height: 1.5rem" src="../assets/img/chat-web.svg" alt="">
          <p class="m-0 font-5 text-center my-2">
            چت با مجری
          </p>
        </router-link>

        <a v-if="data_user.insta_link != null" :href="data_user.insta_link" target="_blank"
           class="item_share d-flex text-decoration-none flex-column align-items-center">
          <img style="width: 1.5rem;height: 1.5rem" src="../assets/img/instagram-web.svg" alt="">
          <p class="m-0 font-5 text-center my-2 text-nowrap">
            اینستاگرام
          </p>
        </a>

        <div v-else class="d-flex flex-column align-items-center">
          <img style="width: 1.5rem;height: 1.5rem" src="../assets/img/not_active_instagram.svg" alt="">
          <p style="color:#666666" class="m-0 font-5 text-center my-2">
            اینستاگرام
          </p>
        </div>

        <a v-if="data_user.telegram_link != null" :href="data_user.telegram_link" target="_blank"
           class="item_share d-flex text-decoration-none flex-column align-items-center">
          <img style="width: 1.5rem;height: 1.5rem" src="../assets/img/telegram-web.svg" alt="">
          <p class="m-0 font-5 text-center my-2">
            تلگرام
          </p>
        </a>

        <div v-else class="d-flex flex-column align-items-center">
          <img style="width: 1.5rem;height: 1.5rem" src="../assets/img/not_active_telegram.svg" alt="">
          <p style="color:#666666" class="m-0 font-5 text-center my-2">
            تلگرام
          </p>
        </div>

        <a v-if="data_user.web_link != null" :href="data_user.web_link" target="_blank"
           class="item_share d-flex text-decoration-none flex-column align-items-center">
          <img style="width: 1.5rem;height: 1.5rem" src="../assets/img/web-web.svg" alt="">
          <p class="m-0 font-5 text-center my-2 text-nowrap">
            وبسایت
          </p>
        </a>

        <div v-else class="d-flex flex-column align-items-center">
          <img style="width: 1.5rem;height: 1.5rem" src="../assets/img/not_active_web.svg" alt="">
          <p style="color:#666666" class="m-0 font-5 text-center my-2">
            وبسایت
          </p>
        </div>

        <a :href="data_user.rubika_link" :class="data_user.rubika_link === null ? 'pe-none':''" class="d-flex text-decoration-none flex-column align-items-center">
          <img v-if="data_user.rubika_link === null" style="width: 1.5rem;height: 1.5rem" src="../assets/img/rubika-NA.png" alt="">
          <img v-else style="width: 1.5rem;height: 1.5rem" src="../assets/img/rubikapng.parspng.com_.png" alt="">
          <p :style="data_user.rubika_link === null ? {color:'#666666'} : {color: '#e15900'}" class="m-0 font-5 text-center my-2">
            روبیکا
          </p>
        </a>

        <a :href="data_user.eita_link" :class="data_user.eita_link === null ? 'pe-none':''" class="d-flex text-decoration-none flex-column align-items-center">
          <img v-if="data_user.eita_link === null" style="width: 1.5rem;height: 1.5rem" src="../assets/img/eta_NA.png" alt="">
          <img v-else style="width: 1.5rem;height: 1.5rem" src="../assets/img/eta_A.png" alt="">
          <p :style="data_user.eita_link === null ? {color:'#666666'} : {color: '#e15900'}" class="m-0 font-5 text-center my-2">
            ایتا
          </p>
        </a>

      </div>
    </div>
  </div>

</template>

<style scoped>

.div_img_products {
  width: 100%;
  height: 325px;
}
.share_list {
  width: 4rem;
  height: 0px;
  overflow: hidden;
  transition: 0.5s;
}
.alert_background {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(79, 78, 78, 0.44);
  display: none;
  z-index: 10;
}

.div_share {
  position: fixed;
  padding-left: 15px;
  bottom: 40px;
  width: 100%;
  max-width: 500px;
}
.holder_navbar_share {
  position: fixed;
  bottom: 15px;
  transition: transform 0.5s ease-in-out;
  transform-origin: center center;
}
.clicked {
  transform: rotate(180deg);
}
#share_list {
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
.categories_gallery {
  padding: 5px;
  width: 150px;
  height: 180px;
}
.next_img {
  background-color: red;
  border-radius: 50%;
}

#slider {
  display: none;
  position: fixed;
  width: 100%;
  max-height: 80vh;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.categories_gallery-web{
  height: 15rem !important;
}
.item_share{
  width: 90%;
  transition: .5s;
  border-radius: 30px;
  padding: 2% 0;
  white-space: nowrap;
  overflow: visible;
  text-decoration: none;
  color: #e15900
}
.item_share:hover{
  background-color: #818285;
  color: white !important;
  outline: 1px solid #e15900;
}
</style>